import { v4 as uuid } from "uuid";
var pintrk = window.pintrk;
export function enablePinterestTracking() {
    pintrk && pintrk("setconsent", true);
}
export function sendPinterestPageViewEvent() {
    pintrk &&
        pintrk("track", "pagevisit", {
            event_id: uuid(),
        });
}
export function sendPinterestAddToCartEvent(product_id, product_name, value, order_quantity, currency) {
    pintrk &&
        pintrk("track", "addtocart", {
            event_id: uuid(),
            value: value,
            order_quantity: order_quantity,
            currency: currency,
            line_items: [
                {
                    product_id: product_id,
                    product_name: product_name,
                },
            ],
        });
}
